<template>
  <b-modal
    id="wizardimport"
    title="Wizard tester"
    size="lg"
    hide-footer
    v-model="show"
    :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
  >
    <wizard-form
      ref="wizardform"
      @onComplete="onComplete"
      @onNextStep="nextStep"
      @onPreviousStep="previousStep"
      @onReset="reset"
    >
      <tab-content title="File Upload" :selected="true">
        <step-file @selected="fileselected" />
      </tab-content>

      <tab-content title="Table Mapping">
        <div class="form-group">
          <label for="companyName">Your Company Name</label>
          <input
            type="text"
            class="form-control"
            :class="hasError('companyName') ? 'is-invalid' : ''"
            placeholder="Enter your Company / Organization name"
            v-model="formData.companyName"
          />
          <div v-if="hasError('companyName')" class="invalid-feedback">
            <div class="error" v-if="!$v.formData.companyName.required">
              Please provide a valid company name.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="numberOfEmployees">Number of Employees</label>
          <input
            type="text"
            class="form-control"
            :class="hasError('numberOfEmployees') ? 'is-invalid' : ''"
            placeholder="Enter Total Number of Employees"
            v-model="formData.numberOfEmployees"
          />
          <div v-if="hasError('numberOfEmployees')" class="invalid-feedback">
            <div class="error" v-if="!$v.formData.numberOfEmployees.required">
              Please provide number of employees in your company.
            </div>
            <div class="error" v-if="!$v.formData.numberOfEmployees.numeric">
              Should be a valid value.
            </div>
          </div>
        </div>
      </tab-content>

      <tab-content title="Import">
        <div class="form-group">
          <label for="referral">From Where did you hear about us</label>
          <select
            :class="hasError('referral') ? 'is-invalid' : ''"
            class="form-control"
            v-model="formData.referral"
          >
            <option>Newspaper</option>
            <option>Online Ad</option>
            <option>Friend</option>
            <option>Other</option>
          </select>
          <div v-if="hasError('referral')" class="invalid-feedback">
            <div class="error" v-if="!$v.formData.referral.required">
              Please select on of the fields.
            </div>
          </div>
        </div>
        <div class="form-group form-check">
          <input
            type="checkbox"
            :class="hasError('terms') ? 'is-invalid' : ''"
            class="form-check-input"
            v-model="formData.terms"
          />
          <label class="form-check-label">I accpet terms & conditions</label>
          <div v-if="hasError('terms')" class="invalid-feedback">
            <div class="error" v-if="!$v.formData.terms.required">
              Please select terms and conditions.
            </div>
          </div>
        </div>
      </tab-content>

    </wizard-form>
  </b-modal>
</template>

<script>
import WizardForm from "../../../components/Wizard/wizard-form.vue";
import TabContent from "../../../components/Wizard/tab-content.vue";
import ValidationHelper from "../../../components/Wizard/validationhelper.vue";

// import StepFile from "../../../components/Wizard/step-filepreview.vue";

import { required, email, numeric, minLength } from "vuelidate/lib/validators";
const checked = (value) => value === true;

export default {
  name: "WizardFile",
  components: {
    WizardForm,
    TabContent,
    // StepFile,
  },
  mixins: [ValidationHelper],
  data() {
    return {
      show: false,
      formData: {
        filename: null,
        sheets: [],
        email: null,
        companyName: null,
        numberOfEmployees: null,
        referral: null,
        terms: false,
      },
      validationRules: [
        { filename: { required } },
        // { companyName: { required }, numberOfEmployees: { required, numeric } },
        // { fullName: { required }, email: { required, email } },
        // { referral: { required }, terms: { checked } },
      ],
    };
  },
  methods: {
    fileselected(f, s) {
      console.log("file selected", f, s);
      this.formData.filename = f
      this.formData.sheets = s
    },
    onComplete() {
      alert("Submitting Form ! Rock On");
      this.$refs.wizardform.changeStatus();
    },

    reset() {
      for (let field in this.formData) {
        this.formData[field] = null;
      }
    },

    nextStep() {
      //   alert("On Next Step");
    },

    previousStep() {
      //   alert("On Previous Step");
    },
  },
};
</script>

<style>
</style>